import Cookies from 'js-cookie'

const state = {
  device: 'desktop',
  size: Cookies.get('size') || 'medium',
  sidebarMaskVisible: false,
}

const mutations = {
  TOGGLE_DEVICE: (state, device) => {
    state.device = device
  },
  SET_SIZE: (state, size) => {
    state.size = size
    Cookies.set('size', size)
  },
  TOGGLE_SIDEBAR_MASK_VISIBLE: (state, visible) => {
    state.sidebarMaskVisible = visible
  },
}

const actions = {
  toggleDevice({ commit }, device) {
    commit('TOGGLE_DEVICE', device)
  },
  setSize({ commit }, size) {
    commit('SET_SIZE', size)
  },
  toggleSidebarMaskVisible({ commit }, visible) {
    commit('TOGGLE_SIDEBAR_MASK_VISIBLE', visible)
  },
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
}
